// @mui
import { Theme } from '@mui/material/styles';

// theme
import { ColorSchema } from '../palette';
//
import { InfoIcon, ErrorIcon, SuccessIcon, WarningIcon } from './CustomIcons';

// ----------------------------------------------------------------------

type AlertSeverity = 'info' | 'success' | 'warning' | 'error';
type AlertVariant = 'standard' | 'filled' | 'outlined';

export default function Alert(theme: Theme) {
  const isLight = theme.palette.mode === 'light';

  const standardStyle = (color: ColorSchema) => ({
    color: theme.palette[color][isLight ? 'darker' : 'lighter'],
    backgroundColor: theme.palette[color][isLight ? 'lighter' : 'darker'],
    '& .MuiAlert-icon': {
      color: theme.palette[color][isLight ? 'main' : 'light'],
    },
  });

  const filledStyle = (color: ColorSchema) => ({
    color: theme.palette[color].contrastText,
  });

  const outlinedStyle = (color: ColorSchema) => ({
    color: theme.palette[color][isLight ? 'darker' : 'lighter'],
    border: `solid 1px ${theme.palette[color][isLight ? 'light' : 'dark']}`,
    backgroundColor: theme.palette[color][isLight ? 'lighter' : 'darker'],
    '& .MuiAlert-icon': {
      color: theme.palette[color][isLight ? 'main' : 'light'],
    },
  });

  const styleFor = (variant: AlertVariant, severity: AlertSeverity) => {
    if (variant === 'standard') return standardStyle(severity);
    if (variant === 'filled') return filledStyle(severity);
    return outlinedStyle(severity);
  };

  const severities: AlertSeverity[] = ['info', 'success', 'warning', 'error'];
  const variants: AlertVariant[] = ['standard', 'filled', 'outlined'];

  return {
    MuiAlert: {
      defaultProps: {
        iconMapping: {
          info: <InfoIcon />,
          success: <SuccessIcon />,
          warning: <WarningIcon />,
          error: <ErrorIcon />,
        },
      },

      styleOverrides: {
        message: {
          '& .MuiAlertTitle-root': {
            marginBottom: theme.spacing(0.5),
          },
        },
        action: {
          '& button:not(:first-of-type)': {
            marginLeft: theme.spacing(1),
          },
        },
      },

      variants: variants.flatMap((variant) =>
        severities.map((severity) => ({
          props: { variant, severity },
          style: styleFor(variant, severity),
        }))
      ),
    },
  };
}
